
import { CentreUrl } from "../../../shared/urls/centre.url";
import { Injectable } from "@angular/core";
import { BaseService } from "../../../shared/services/base.service";
import { UserUrl } from '../../../shared/urls/user.url';

@Injectable()
export class ManageVaccineService {
  constructor(public baseService: BaseService) {
  }
  getReasonList() {
    const url = CentreUrl.GET_ALL_REASON;
    return this.baseService.getData(url);
  }
  addNewVaccineBatch(param) {
    const url = CentreUrl.ADD_NEW_VACCINE_BATCH;
    return this.baseService.postData(url, param);
  }
  updateVaccineBatch(id, param) {
    const url = CentreUrl.UPDATE_VACCINE_BATCH + `${id}`;
    return this.baseService.put(url, param);
  }
  getVaccineBatchById(id) {
    const url = CentreUrl.GET_VACCINE_BATCH_BY_ID.replace('{id}', id);
    return this.baseService.getById(url, id);
  }
  removeVaccineBatch(id) {
    const url = CentreUrl.REMOVE_VACCINE_BATCH + `${id}`;
    return this.baseService.delete(url);
  }

  getListVaccine(id) {
    const url = UserUrl.GET_CENTRE_VACCINES;
    return this.baseService.getById(url, id);
  }

  getCentres() {
    const centreUrl = UserUrl.GET_ALL_CENTRE;
    return this.baseService.getData(centreUrl);
  }

  getDataBatch(param) {
    const url = UserUrl.GET_BATCHS;
    return this.baseService.getData(url, param);
  }

  getCentreVaccine(id, useVaccineId) {
    const url = CentreUrl.GET_ALL_VACCINE;
    return this.baseService.getData(url, { id: id, useVaccineId: useVaccineId });
  }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-vaccine/manage-vaccine.service.ts